(function () {
  var toggle = document.querySelector('[data-menu-toggle]');
  var menu = document.querySelector('[data-menu]');

  if (!toggle || !menu) {
    return;
  }

  toggle.addEventListener('click', function () {
    var isOpen = menu.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  });

  window.addEventListener('resize', function () {
    if (window.innerWidth > 991) {
      menu.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
    }
  });
})();
function updateCartCount() {
  fetch('/cart.js')
    .then((response) => response.json())
    .then((cart) => {
      const cartCount = document.querySelector('[data-cart-count]');
      if (!cartCount) return;

      cartCount.textContent = cart.item_count;

      if (cart.item_count > 0) {
        cartCount.classList.remove('is-hidden');
      } else {
        cartCount.classList.add('is-hidden');
      }
    })
    .catch((error) => {
      console.error('Failed to update cart count:', error);
    });
}

(function initProductRowCarousels() {
  function initializeProductRows() {
    document.querySelectorAll('[data-ci-product-scroller]').forEach(function (scroller) {
      if (scroller.dataset.ciProductScrollerReady === 'true') return;

      var row = scroller.closest('[data-ci-product-row]');
      var previousButton = row ? row.querySelector('[data-ci-product-scroller-prev]') : null;
      var nextButton = row ? row.querySelector('[data-ci-product-scroller-next]') : null;

      if (!row || !previousButton || !nextButton) return;

      scroller.dataset.ciProductScrollerReady = 'true';

      function updateNavigation() {
        var maxScroll = Math.max(scroller.scrollWidth - scroller.clientWidth, 0);
        var hasOverflow = maxScroll > 1;
        var currentScroll = scroller.scrollLeft;

        row.classList.toggle('has-overflow', hasOverflow);
        previousButton.disabled = !hasOverflow || currentScroll <= 1;
        nextButton.disabled = !hasOverflow || currentScroll >= maxScroll - 1;
      }

      previousButton.addEventListener('click', function () {
        scroller.scrollBy({ left: -scroller.clientWidth, behavior: 'smooth' });
      });

      nextButton.addEventListener('click', function () {
        scroller.scrollBy({ left: scroller.clientWidth, behavior: 'smooth' });
      });

      scroller.addEventListener('scroll', updateNavigation, { passive: true });
      window.addEventListener('resize', updateNavigation);

      if ('ResizeObserver' in window) {
        new ResizeObserver(updateNavigation).observe(scroller);
      }

      updateNavigation();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeProductRows);
  } else {
    initializeProductRows();
  }
})();

(function initSeasonalDealSliders() {
  function initializeSeasonalDealSliders() {
    document.querySelectorAll('[data-mg-seasonal-deals]').forEach(function (root) {
      if (root.dataset.mgSeasonalDealsReady === 'true') return;

      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-mg-seasonal-slide]'));
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-mg-seasonal-dot]'));
      var previous = root.querySelector('[data-mg-seasonal-prev]');
      var next = root.querySelector('[data-mg-seasonal-next]');
      var autoplay = root.dataset.autoplay === 'true';
      var interval = Math.max(Number(root.dataset.interval || 6) * 1000, 4000);
      var motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      var index = 0;
      var timer = null;

      root.dataset.mgSeasonalDealsReady = 'true';

      function pauseVideos() {
        root.querySelectorAll('video').forEach(function (video) {
          video.pause();
        });
      }

      function playActiveVideo() {
        pauseVideos();
        if (!autoplay || motionQuery.matches || document.hidden || !slides[index]) return;

        slides[index].querySelectorAll('video').forEach(function (video) {
          var playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(function () {});
          }
        });
      }

      function stop() {
        if (timer) {
          window.clearInterval(timer);
          timer = null;
        }
        pauseVideos();
      }

      function start() {
        stop();
        playActiveVideo();
        if (!autoplay || slides.length < 2 || motionQuery.matches || document.hidden) return;
        timer = window.setInterval(function () {
          goTo(index + 1);
        }, interval);
      }

      function goTo(nextIndex) {
        if (!slides.length) return;
        index = (nextIndex + slides.length) % slides.length;

        slides.forEach(function (slide, slideIndex) {
          var isActive = slideIndex === index;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });

        dots.forEach(function (dot, dotIndex) {
          var isActive = dotIndex === index;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-current', isActive ? 'true' : 'false');
        });

        playActiveVideo();
      }

      if (previous) {
        previous.addEventListener('click', function () {
          goTo(index - 1);
          start();
        });
      }

      if (next) {
        next.addEventListener('click', function () {
          goTo(index + 1);
          start();
        });
      }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          goTo(Number(dot.dataset.mgSeasonalDot));
          start();
        });
      });

      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', function (event) {
        if (!root.contains(event.relatedTarget)) start();
      });

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stop();
        else start();
      });

      if (typeof motionQuery.addEventListener === 'function') {
        motionQuery.addEventListener('change', start);
      } else if (typeof motionQuery.addListener === 'function') {
        motionQuery.addListener(start);
      }

      goTo(0);
      start();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeSeasonalDealSliders);
  } else {
    initializeSeasonalDealSliders();
  }

  document.addEventListener('shopify:section:load', initializeSeasonalDealSliders);
})();

(function () {
  var observer = null;
  var pendingTargets = new Set();
  var scrollCheckScheduled = false;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var sectionSelector = '#MainContent > .shopify-section, body > #shopify-section-footer';
  var cardSelector = [
    '.ci-product-scroller__item',
    '.ci-product-card',
    '.ci-category-card',
    '.mg-collection__card',
    '.mg-collection-card',
    '.mg-search__card',
    '.mg-home-featured-grid__item',
    '.mg-payment-guide__partner-card',
    '.mg-payment-guide__detail-card'
  ].join(', ');

  function markVisible(target) {
    target.classList.add('is-scroll-visible');
    pendingTargets.delete(target);
    if (observer) observer.unobserve(target);
  }

  function revealEntries(entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;

      markVisible(entry.target);
    });
  }

  function revealSkippedTargets() {
    scrollCheckScheduled = false;
    pendingTargets.forEach(function (target) {
      if (target.getBoundingClientRect().bottom < 0) markVisible(target);
    });
  }

  function scheduleSkippedTargetCheck() {
    if (scrollCheckScheduled) return;
    scrollCheckScheduled = true;
    window.requestAnimationFrame(revealSkippedTargets);
  }

  function initializeScrollReveals() {
    if (!('IntersectionObserver' in window) || reduceMotion.matches) return;

    if (!observer) {
      observer = new IntersectionObserver(revealEntries, {
        rootMargin: '0px 0px -40px 0px',
        threshold: 0.08
      });
    }

    var sections = Array.prototype.slice.call(document.querySelectorAll(sectionSelector));
    var cards = Array.prototype.slice.call(document.querySelectorAll('#MainContent ' + cardSelector));
    var targets = sections.concat(cards);
    if (!targets.length) return;

    document.documentElement.classList.add('mg-scroll-reveal-ready');

    targets.forEach(function (target) {
      if (target.classList.contains('mg-scroll-reveal')) return;

      target.classList.add('mg-scroll-reveal');
      pendingTargets.add(target);
      if (target.matches(cardSelector)) {
        var section = target.closest('.shopify-section');
        var siblings = section ? Array.prototype.slice.call(section.querySelectorAll(cardSelector)) : [];
        var cardIndex = siblings.indexOf(target);
        target.style.setProperty('--mg-scroll-reveal-delay', Math.min(cardIndex, 5) * 60 + 'ms');
      }

      if (target.getBoundingClientRect().bottom < 0) markVisible(target);
      else observer.observe(target);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeScrollReveals);
  } else {
    initializeScrollReveals();
  }

  window.addEventListener('scroll', scheduleSkippedTargetCheck, { passive: true });
  document.addEventListener('shopify:section:load', initializeScrollReveals);
})();
